export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14659.ba12b709.jpg";